module.exports = __webpack_public_path__ + "img/img29.87d031a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img29.jpg
// module id = 326
// module chunks = 0